import { useSubscription } from '@apollo/client'

import {
   SendQueryResponseInThreadSubscriptionDocument as CompletedMessageDataDocument,
   SendQueryResponseInThreadSubscriptionSubscription as CompletedMessageDataSubscription,
   SendQueryResponseInThreadSubscriptionSubscriptionVariables as CompletedMessageDataVariables,
   SendQueryStreamedDataInThreadSubscriptionDocument as StreamedDataDocument,
   SendQueryStreamedDataInThreadSubscriptionSubscription as StreamedDataSubscription,
   SendQueryStreamedDataInThreadSubscriptionSubscriptionVariables as StreamedDataVariables
} from '@flowwai-frontend/bps-officer-web/ai-chat-support/data-access'
import {
   LOADING_MESSAGE_ID,
   ThreadModel
} from '@flowwai-frontend/shared-web/ai-chat-support/data-access'
import { scrollMessageIntoView } from '@flowwai-frontend/shared-web/ai-chat-support/ui'

export const useAIChatSupport = (threadModel: ThreadModel) => {
   useSubscription<StreamedDataSubscription, StreamedDataVariables>(
      StreamedDataDocument,
      {
         variables: {
            threadId: threadModel.threadId
         },
         onData({ data }) {
            const responseData =
               data.data?.sendQueryStreamedDataInThreadSubscription

            threadModel.appendLoadingMessage(responseData?.response ?? '')

            const stringifiedMessageId = `MESSAGE:${LOADING_MESSAGE_ID}`
            scrollMessageIntoView(stringifiedMessageId)
         }
      }
   )

   useSubscription<
      CompletedMessageDataSubscription,
      CompletedMessageDataVariables
   >(CompletedMessageDataDocument, {
      variables: {
         threadId: threadModel.threadId
      },
      onData({ data }) {
         const responseData = data.data?.sendQueryResponseInThreadSubscription

         switch (responseData?.__typename) {
            case 'SendQueryResponseInThreadResult': {
               threadModel.updateLoadingMessageStatus(null)

               threadModel.setName(responseData.threadName)

               const newMessage = responseData.threadMessage

               threadModel.addRecentMessage({
                  messageId: newMessage.messageId,
                  content: newMessage.content,
                  type: 'REPLY',
                  timeStamp: new Date(newMessage.createdAt)
               })
               const stringifiedMessageId = `MESSAGE:${newMessage.messageId}`
               scrollMessageIntoView(stringifiedMessageId, {
                  behavior: 'smooth',
                  block: 'start'
               })
               threadModel.updateLoadingMessage('')

               break
            }
         }
      }
   })
}
